import { Component, inject } from '@angular/core'

import { ReleaseService } from '../../changelog/release.service'
import { FrameDetectionService } from '../shared/services'

@Component({
  standalone: false,
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent {
  private releaseService = inject(ReleaseService)
  private frameDetectionService = inject(FrameDetectionService)
  public latest: string
  public isIframe: boolean = this.frameDetectionService.isIframe()

  public sidebarData: Array<{
    groupTitle: string
    groupIcon: string
    items: Array<{
      menuTitle: string
      routerLink: string
    }>
  }> = []

  constructor() {
    this.latest = this.releaseService.getLatestVersion()

    this.sidebarData = [
      {
        groupTitle: 'Account',
        groupIcon: 'k-i-user',
        items: [
          { menuTitle: 'Profile', routerLink: 'profile' },
          { menuTitle: 'Environment', routerLink: 'environment' },
          ...(!this.isIframe
            ? [{ menuTitle: 'Appearance', routerLink: 'appearance' }]
            : []),
          { menuTitle: 'API Keys', routerLink: 'api-keys' },
          { menuTitle: 'Bookmarks', routerLink: 'favorites' },
        ],
      },
      // Only include the company group if NOT in iframe
      ...(this.isIframe
        ? []
        : [
            {
              groupTitle: 'Company',
              groupIcon: 'k-i-globe',
              items: [
                {
                  menuTitle: 'Company Information',
                  routerLink: 'company-information',
                },
                {
                  menuTitle: 'Manage Users',
                  routerLink: 'manage-users',
                },
              ],
            },
          ]),
    ]
  }
}
